<div class="root">
  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
  <div *ngIf="!loading">
    <div class="container my-animation" *ngFor="let activity of activities">
      <app-activity-feed-item [activity]="activity"></app-activity-feed-item>
    </div>
  </div>
</div>
